import { request } from '../request';
import { generateIdempotencyKey } from '@/hooks/useIdempotencyKey';

/**
 * 获取我的供给方档案数据
 * GET /provider-profile
 * 返回当前账号对应的服务商档案、发布档案及草稿数据
 */
export function fetchGetProviderProfile() {
  return request<Api.Provider.ProviderProfileResponse>({
    url: '/provider-profile',
    method: 'GET'
  });
}

/**
 * 保存我的供给方档案草稿
 * PUT /provider-profile
 *
 * @param data 请求体参数 (SaveProviderProfileRequest)，包含头像、展示名称、服务方式、日薪、常驻城市、技能标签、作品集等信息
 */
export function fetchSaveProviderProfileDraft(
  data: Api.Provider.SaveProviderProfileRequest
) {
  return request<Api.Provider.ProviderProfileResponse>({
    url: '/provider-profile',
    method: 'PUT',
    data
  });
}

/**
 * 提交我的供给方档案进入平台审核
 * POST /provider-profile/submit
 */
export function fetchSubmitProviderProfile() {
  return request<Api.Provider.ProviderProfileResponse>({
    url: '/provider-profile/submit',
    method: 'POST'
  });
}

/**
 * 取消供给方大厅展示 (下架)
 * POST /provider-profile/offline
 */
export function fetchOfflineProviderProfile() {
  return request<Api.Provider.ProviderProfileResponse>({
    url: '/provider-profile/offline',
    method: 'POST'
  });
}

/**
 * 恢复供给方大厅展示 (恢复上架)
 * POST /provider-profile/restore
 */
export function fetchRestoreProviderProfile() {
  return request<Api.Provider.ProviderProfileResponse>({
    url: '/provider-profile/restore',
    method: 'POST'
  });
}

/**
 * 分页查询公开供给方档案大厅列表
 * GET /providers
 *
 * @param params 查询参数 (page, page_size, provider_type, category_code, city_code, keyword)
 */
export function fetchQueryPublicProviders(
  params?: Api.Provider.QueryPublicProvidersParams
) {
  return request<Api.Provider.ProviderPublicProfilePageResponse>({
    url: '/providers',
    method: 'GET',
    params
  });
}

/**
 * 获取公开供给方档案详情
 * GET /providers/{id}
 *
 * @param id 供给方档案 ID
 */
export function fetchGetPublicProviderDetail(id: number | string) {
  return request<Api.Provider.ProviderPublicProfileResponse>({
    url: `/providers/${id}`,
    method: 'GET'
  });
}

/**
 * 查看已授权的供给方联系方式 (支持幂等控制)
 * POST /providers/{id}/contact-view
 *
 * @param id 供给方档案 ID
 * @param requestId 可选幂等请求 ID Header (X-Request-ID)，未传时将自动生成全局唯一 ID
 */
export function fetchViewProviderContact(id: number | string, requestId?: string) {
  const finalRequestId = requestId || generateIdempotencyKey(`contact_view_${id}`);
  return request<Api.Provider.ProviderContactResponse>({
    url: `/providers/${id}/contact-view`,
    method: 'POST',
    headers: { 'X-Request-ID': finalRequestId }
  });
}
